import { useEffect } from "react";

export const useScrollToTop = (smooth: boolean = true) => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: smooth ? "smooth" : "auto",
    });
  };

  return scrollToTop;
};

export const useAutoScrollToTop = (trigger: any, smooth: boolean = true) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: smooth ? "smooth" : "auto",
    });
  }, [trigger, smooth]);
};

export default useScrollToTop;
